/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Group from "material/group/group";
import Copy from "material/copy/copy";
import Title from "material/copy/title/title";
import Notification from 'material/message/notification/notification';
// utils
import { months } from 'utils/months';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/account/agreementform/agreementform_styles';


/* ========== ~~~~~~~~~~ AGREEMENT : PAGE ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class AgreementForm extends Component{
    constructor(props){
        super(props);
        this.iframeEl = null;

        this.handleMessage = this.handleMessage.bind(this);
    };

    componentDidMount() {
        this.setEventListener();
        if(this.iframeEl){
            this.iframeEl.contentWindow.document.addEventListener('closeAndNoShow', evt => {console.log(evt)})
        } 
        this.props.getAgreementInfo(this.props.accountUUID);
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.handleMessage);
    }

    setEventListener() {
        window.addEventListener("message", this.handleMessage);
    }

    handleMessage(e) {
        if(e.data === '{"type":"ESIGN","data":{}}'){
               this.props.updateAgreementInfo(this.props.agreementUUID, this.props.accountUUID)
        }
    }

    handleDateSignedRender = () =>{
       let date = new Date(this.props.agreementAcceptedAt);

       return `${months[date.getMonth()]} ${date.getDate()} ${date.getFullYear()}`
    };


    render(){
        return(
            <div className={`agreementform ${this.props.classes.agreementform}`}>
                <Copy name={`page-copy`}>
                    <Title variant={`withtip`}>
                        <h2>Agreement Form</h2>
                    </Title>
                </Copy>
                <Group name={`page-details`}>
                    {this.props.agreementSigned && <Notification variant={`neutral`} size={`full`} icon={`exclamation-triangle`} text={<span>{`The Agreement was signed on ${this.handleDateSignedRender()}.`}</span>} />}
                    {!this.props.agreementSigned && <iframe id={`agreementForm`} title={`agreementform`} ref={input => this.iframeEl = input} src={`https://secure.na1.echosign.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhAgptKk8fUc4cFSzDkCGc7BAEqL1v-N4gITus-I84Fc16Mvz2KVD2sts7LU1KKxKM4*&hosted=false&token=&firstName=&lastName=&nameEditable=true`}/>}
                </Group>
            </div>
        );
    }

};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(AgreementForm);